// extracted by mini-css-extract-plugin
export default {"Box":"view-loading-progress-bar-module__Box--FUOM9","ProgressBar":"view-loading-progress-bar-module__ProgressBar--EfwiV","Loading":"view-loading-progress-bar-module__Loading--gWQ68"};